import { CustomerFilters, CustomersTable } from "modules/CustomersDashboard/components";

export const CustomersDashboard = () => (
  <>
    <CustomerFilters />
    <CustomersTable />
  </>
);
